import {Component, OnInit} from '@angular/core';
import {BmBillingAreaBaseComponent} from '../bm-billing-area-base.component';


@Component({
    selector: 'bm-billing-area-full',
    templateUrl: 'bm-billing-area-full.component.html',
    standalone: false
})
export class BmBillingAreaFullComponent extends BmBillingAreaBaseComponent implements OnInit {

    ngOnInit() {
        super.ngOnInit();
    }

}
